(()=>{
  const q=(new URLSearchParams(location.search).get('filtro')||'').toLowerCase();
  if(!q||!location.pathname.includes('/pages/pernoctar'))return;

  const matchers={
    area:t=>t.includes('areas')||t.includes('area')&&t.includes('autocaravana'),
    camping:t=>t.includes('camping'),
    descanso:t=>t.includes('descanso'),
    servicio:t=>t.includes('servicio')&&!t.includes('vaciado'),
    picnic:t=>t.includes('picnic'),
    vaciado:t=>t.includes('vaciado'),
    parking:t=>t.includes('parking')
  };
  const wanted=matchers[q];
  if(!wanted)return;

  const norm=s=>String(s||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim();
  const buttons=()=>[...document.querySelectorAll('#cvgSheetCats button.cvg-chip')];
  const findTarget=()=>buttons().find(b=>wanted(norm(b.textContent)));

  const wait=ms=>new Promise(r=>setTimeout(r,ms));

  async function apply(){
    let target=findTarget();
    if(!target)return false;

    if(!target.classList.contains('active')){
      target.click();
      await wait(120);
    }

    for(let guard=0;guard<12;guard++){
      const fresh=buttons();
      const freshTarget=fresh.find(b=>wanted(norm(b.textContent)));
      const other=fresh.find(b=>b.classList.contains('active')&&b!==freshTarget);
      if(!other)break;
      other.click();
      await wait(120);
    }

    target=findTarget();
    if(target&&!target.classList.contains('active')){
      target.click();
      await wait(120);
    }

    // Importante: los botones de categoría solo cambian el estado interno.
    // Este botón es el que realmente vuelve a pintar la lista y el mapa.
    const applyBtn=document.getElementById('cvgApplyFilters');
    if(applyBtn){
      applyBtn.click();
      await wait(180);
    }

    const sheet=document.getElementById('cvgFilterSheet');
    if(sheet)sheet.hidden=true;

    const status=document.getElementById('cvgStatus');
    const finalTarget=findTarget();
    if(status&&finalTarget){
      status.textContent=`Filtro activo: ${(finalTarget.textContent||'').trim()}`;
    }
    return true;
  }

  let busy=false,tries=0;
  const timer=setInterval(async()=>{
    if(busy)return;
    busy=true;
    tries++;
    const ok=await apply();
    busy=false;
    if(ok||tries>40)clearInterval(timer);
  },250);
})();